<template>
  <BreadCrumb PageTitle=" Liste des éléments électriques"/>
    <ListeElementElectrique />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import ListeElementElectrique from "@/components/ELementElectrique/ListeElementElectrique.vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";

    export default defineComponent({
      name: "ListeElementElectriquePage",
      components: {
        ListeElementElectrique,
      },
    });
  </script>